// extracted by mini-css-extract-plugin
export default {"wrapper":"Document_wrapper__BOkQN"};